<template>
    <div class="online_quitting no-trans" v-loading="loading">
        <div class="online_quitting_box">            
            <div class="top_box">
                <img src="@/assets/img/login/Frame.png" alt="">
                <router-link class="span1" to="/home" style="color: inherit; text-decoration: none;">首页</router-link> > <router-link class="breadcrumb_link" to="/online" style="color: inherit; text-decoration: none;">法律咨询</router-link> > <span aria-current="page">在线咨询</span>
            </div>
            <div class="chat_box">
                <div class="chat">
                    <div class="cat_title_flex">
                        <div class="titles">
                            在线咨询
                        </div>
                    </div>
                    <div class="textarea_box">
                        <textarea maxlength="500" aria-label="描述您的法律问题" placeholder="现非工作时间，可先留下你的疑问。" v-model="texts" ></textarea>
                    </div>
                    <div class="img_list">
                        <div class="imgs" v-for="(item,index) in img_list" :key="index">
                            <img :src="item" alt="" class="imgs1"> 
                            <img src="@/assets/img/login/clear.png" alt="删除图片" role="button" tabindex="0" class="imgs2" @keydown.enter.prevent="handle_clear(index)" @keydown.space.prevent="handle_clear(index)" @click="handle_clear(index)"> 
                        </div>
                        <div class="imgs_add" role="button" tabindex="0" aria-label="添加咨询图片" @keydown.enter.prevent="handle_img_add" @keydown.space.prevent="handle_img_add" @click="handle_img_add">
                            <div class="img_add_img">
                                <img src="../../assets/img/index/legal/add_img.png" alt=""> 
                            </div>
                            <div class="add_text">添加图片</div>
                        </div>
                    </div>
                    <div class="chat_nums">
                        <div class="nums_text">请描述您的问题（0-500字）</div>
                    </div>
                    <div class="btns_flex">
                        <div class="nums_text">{{ texts.length }}/500</div>
                        <div class="btns" role="button" tabindex="0" @keydown.enter.prevent="handle_end" @keydown.space.prevent="handle_end" @click="handle_end">提交</div>
                    </div>
                </div>
                <div class="chat_flex">
                    <div class="btns1">法律裁判点评网</div>
                    <div class="btns1">已有 <span>{{ userNum }}</span> 人提出问题</div>
                    <div class="btns1">律师已解答：<span>{{ lawyerNum }}</span> 问题</div>
                </div>
            </div>
        </div>
        <online_success ref="online_success"></online_success>
        <upload  v-show="false" ref="uploads" :show_type="true" :types="types"></upload>


    </div>
</template>
<script>
import {
    mapState
} from 'vuex'

import online_success from '@/components/legal_advice/online_success.vue'//提交成功

import upload from '@/components/upload/upload.vue'


export default {
    components: {
        online_success,
        upload,

    },
    name: "homes",
    data() {
        return {
            types:JSON.stringify(['jpg','png']),
            loading: false,
            texts:'',
            img_list:[],
            userNum:'',
            lawyerNum:'',
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.get_data()
    },
    methods: {
        get_data(){
            this.loading=true
            this.$api("leaveData", {
            
			}, "get").then((res) => {
                this.loading = false
                console.log('咨询数量',res)
                if (res.code == 1) {
                    this.userNum=res.data.userNum//用户提问总数
                    this.lawyerNum=res.data.lawyerNum//律师答复总数
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_clear(index){
            console.log('img_list',this.img_list)
            this.img_list.splice(index,1)
        },
        //触发上传
        handle_img_add(){
            let datas={
                
            }
            this.$refs.uploads.uploadFile(datas)
        },
         //上传图片
         upload_url(res_data,datas){
            this.img_list.push(res_data.path)
        },
        //删除图片
        // handle_clear(index,text){
        //     this[text].splice(index,1)
        // },
        handle_home(){
            this.$router.push({
                path:'/home'
            })
        },
        change_banner(e){
            // console.log('却换触发',e)
            this.banner_ac=e
        },
        handle_end(){
            if(!this.texts){
                alertErr('请输入描述')
                return
            }
            if(this.img_list.length==0){
                alertErr('请上传图片')
                return
            }
            this.loading=true
            this.$api("leaveMsgAppoint", {
                content:this.texts,
                images:this.img_list.join(',')
			}, "post").then((res) => {
                this.loading = false
                console.log('提交用户信息',res)
                if (res.code == 1) {
                    this.$refs.online_success.handle_open()
                } else {
                    alertErr(res.msg)
                }
            });
        },

    },

}
</script>
<style scoped lang="less">
.online_quitting {
    width: 100%;
    // height: 900px;
    padding-bottom: 200px;
    background-color: #F5F5F5;
    .online_quitting_box{
        width: 1440px;
        height: 100%;
        margin: auto;
        .top_box{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding: 20px 0;

            .span1 {
                cursor: pointer;
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }
        .chat_box{
            width: 960px;
            height: 560px;
            // background: #FFFFFF;
            // box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
            // border-radius: 20px 20px 20px 20px;
            margin: auto;
            .chat{
                width: 960px;
                height: 560px;
                background: #FFFFFF;
                box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                border-radius: 20px 20px 20px 20px;
                .cat_title_flex{
                    display: flex;
                    align-content: center;
                    justify-content: center;
                    border-bottom: 1px solid #E8E8E8;
                    height: 50px;
                    padding: 0 32px;

                    .titles{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 16px;
                        color: #333333;
                        // line-height: 50px;
                        display: flex;
                        align-items: center;
                        img{
                            width: 17px;
                            height: 17px;
                            margin-right: 8px;
                        }
                    }
                   
                }
                .textarea_box{
                    padding:15px 32px;
                    height: 300px;
                    textarea{
                        width: 100%;
                        height: 100%;
                    }
                }
                .img_list{
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    padding: 0 32px;
                    .imgs{
                        width: 70px;
                        height: 70px;
                        background: rgba(206,206,206,0.04);
                        border: 1px solid rgba(0,0,0,0.15);
                        margin-right: 10px;
                        position: relative;
                        .imgs1{
                            width: 100%;
                            height: 100%;
                        }
                        .imgs2{
                            position: absolute;
                            right: 0;
                            top: 0;
                            cursor: pointer;
                            width: 20px;
                            height: 20px;
                        }
                    }
                    .imgs_add{
                        width: 70px;
                        height: 70px;
                        background: rgba(206,206,206,0.04);
                        border: 1px dashed  rgba(0,0,0,0.15);
                        cursor: pointer;
                        padding-top: 16px;
                        .img_add_img{
                            width: 22px;
                            height: 22px;
                            border: 1px dashed  rgba(0,0,0,0.15);
                            margin: auto;
                            display: flex;
                            align-items: center;
                            img{
                                width: 22px;
                                height: 22px;
                            }
                        }
                        .add_text{
                            padding-top: 5px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 9px;
                            color: #878787;
                            text-align: center;
                        }
                    }
                }
                .chat_nums{
                    width: 960px;
                    height: 36px;
                    background: #F5F5F5;
                    border-radius: 0px 0px 0px 0px;
                    margin-top: 16px;
                    padding: 0 32px;
                    .nums_text{
                        line-height: 36px; 
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #9C9EA0;

                    }
                }
                .btns_flex{
                    display: flex;
                    align-items: end;
                    justify-content: end;
                    // align-content: end;
                    padding: 0 32px;
                    padding-top: 28px;
                    .nums_text{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        margin-right: 24px;
                    }
                    .btns{
                        width: 80px;
                        height: 36px;
                        background: #377CFD;
                        border-radius: 6px 6px 6px 6px;
                        text-align: center;
                        line-height: 36px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        cursor: pointer;
                    }
                }
            }
            .chat_flex{
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 40px;
                padding-top: 32px;
                .btns1{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #666666;
                    span{
                        color: #377CFD;
                    }
                }

            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .online_quitting.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-bottom: 16px;
    }
    .online_quitting.no-trans .online_quitting_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .online_quitting.no-trans .online_quitting_box .top_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        padding: 16px 0;
    }
    .online_quitting.no-trans .online_quitting_box .top_box img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        margin: auto;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .cat_title_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        height: auto;
        padding: 0 16px;
        min-height: 44px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .cat_title_flex .titles {
        font-size: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .cat_title_flex .titles img {
        width: 17px;
        height: 17px;
        margin-right: 8px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .textarea_box {
        padding: 15px 16px;
        min-height: 0;
        height: auto;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .img_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 0 16px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .img_list .imgs {
        width: 70px;
        height: 70px;
        margin-right: 10px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .img_list .imgs .imgs2 {
        width: 20px;
        height: 20px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .img_list .imgs_add {
        width: 70px;
        height: 70px;
        padding-top: 16px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .img_list .imgs_add .img_add_img {
        width: 22px;
        height: auto;
        margin: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 22px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .img_list .imgs_add .img_add_img img {
        width: 22px;
        height: 22px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .img_list .imgs_add .add_text {
        padding-top: 5px;
        font-size: 14px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .chat_nums {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 36px;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
        padding: 0 16px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .chat_nums .nums_text {
        line-height: 36px;
        font-size: 14px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .btns_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 0 16px;
        padding-top: 16px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .btns_flex .nums_text {
        font-size: 14px;
        margin-right: 16px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat .btns_flex .btns {
        width: 80px;
        height: auto;
        border-radius: 6px 6px 6px 6px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 0 16px;
        padding-top: 16px;
    }
    .online_quitting.no-trans .online_quitting_box .chat_box .chat_flex .btns1 {
        font-size: 16px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
@media (max-width: 1024px) {
    .online_quitting.no-trans {
        padding: 0 12px 28px;
        .online_quitting_box {
            .top_box { padding: 0 4px; min-height: 48px; gap: 4px 6px; font-size: 13px; }
            .top_box img { margin-right: 0; }
            .top_box .span1, .top_box .breadcrumb_link { display: inline-flex; align-items: center; min-height: 44px; }
            .chat_box {
                max-width: 720px;
                .chat {
                    padding: 0 16px 20px; border-radius: 0; box-shadow: none;
                    .cat_title_flex { justify-content: flex-start; min-height: 60px; padding: 16px 0; border-bottom: 1px solid #edf0f4; }
                    .cat_title_flex .titles { font-size: 20px; line-height: 28px; font-weight: 600; }
                    .textarea_box {
                        height: auto; padding: 16px 0;
                        textarea { display: block; box-sizing: border-box; width: 100%; height: 208px; min-height: 160px; padding: 12px; border: 1px solid #dfe5ee; border-radius: 4px; background: #fbfcfe; font-size: 16px; line-height: 1.8; color: #29384b; resize: vertical; }
                        textarea:focus { outline: 0; border-color: #377cfd; }
                        textarea::placeholder { color: #929caa; }
                    }
                    .img_list {
                        align-items: flex-start; gap: 12px; padding: 0;
                        .imgs, .imgs_add { box-sizing: border-box; flex: 0 0 72px; width: 72px; height: 72px; margin: 0; border-radius: 4px; }
                        .imgs .imgs1 { object-fit: cover; border-radius: 4px; }
                        .imgs .imgs2 { box-sizing: content-box; width: 16px; height: 16px; padding: 14px; top: -14px; right: -14px; }
                        .imgs_add { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; padding: 0; background: #f5f8fc; border-color: #c5d3e5; }
                        .imgs_add .img_add_img { width: 22px; height: 22px; min-height: 0; margin: 0; border: 0; }
                        .imgs_add .add_text { padding: 0; font-size: 13px; line-height: 20px; color: #697586; }
                    }
                    .chat_nums { height: auto; margin: 14px 0 0; padding: 0; background: transparent; }
                    .chat_nums .nums_text { font-size: 13px; line-height: 22px; color: #85909f; }
                    .btns_flex {
                        display: grid; grid-template-columns: 1fr; gap: 12px; padding: 0;
                        .nums_text { text-align: right; margin: 0; font-size: 13px; line-height: 22px; color: #85909f; }
                        .btns { width: 100%; height: 46px; min-height: 46px; padding: 0; font-size: 16px; line-height: 46px; border-radius: 4px; }
                    }
                }
                .chat_flex {
                    display: grid; grid-template-columns: 1fr; gap: 4px; padding: 16px;
                    .btns1 { min-height: 0; padding: 0; font-size: 13px; line-height: 24px; overflow-wrap: anywhere; }
                    .btns1:first-child { grid-column: ~"1 / -1"; color: #85909f; }
                    .btns1 span { font-weight: 600; }
                }
            }
        }
        /deep/ .enroll_success_box.no-trans .el-dialog__wrapper .el-dialog {
            width: calc(100% - 24px); max-width: 440px; border-radius: 8px; overflow: hidden;
            .el-dialog__header { padding: 18px 56px 16px 16px; background: #fff; }
            .el-dialog__headerbtn { width: 44px; height: 44px; top: 6px; right: 6px; }
            .el-dialog__body { padding: 20px 16px; }
            .dialog_box .texts { font-size: 15px; line-height: 26px; color: #697586; }
            .dialog_box .images img { width: 56px; height: 56px; }
            .dialog_box .btn_flex { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; padding-top: 20px; }
            .dialog_box .btn_flex .bnts1, .dialog_box .btn_flex .bnts2 { width: 100%; min-width: 0; height: 46px; margin: 0; line-height: 44px; font-size: 14px; }
        }
    }
}
</style>
